import _ from 'lodash';

import React from 'react';

import {GocardlessItem} from './components';
import Button from 'components/Button';

import {formatDate} from 'utils/datetime';

import './styles.css';

interface GocardlessInvitation {
  id: number;
  sentAt: string;
  isActive: boolean;
  customerName: string;
  customerEmail: string;
  status: string;
  gocardlessUrl: string;
}

interface GocardlessCustomer {
  id: number;
  createdAt: string;
  isActive: boolean;
  name: string;
  email: string;
  customerName: string;
  customerEmail: string;
  status: string;
  gocardlessUrl: string;
}

interface GocardlessPaymentMethodProps {
  invitation?: GocardlessInvitation;
  customer?: GocardlessCustomer;
  openSetupGocardlessModal: () => void;
  openGocardlessCustomerModal: (id: number) => void;
  removeInvitation: (invitationId: number) => void;
  removeCustomer: (customerId: number) => void;
  openGoCardlessItemUrlLink: (event, url) => void;
}

const GocardlessPaymentMethod: React.SFC<GocardlessPaymentMethodProps> = ({
  invitation,
  customer,
  openSetupGocardlessModal,
  openGocardlessCustomerModal,
  removeInvitation,
  removeCustomer,
  openGoCardlessItemUrlLink
}) => {
  const showItemsContainer = !_.isNil(invitation) || !_.isNil(customer);

  return (
    <div className="GocardlessPaymentMethod">
      {showItemsContainer && (
        <div className="itemsContainer">
          {!_.isNil(invitation) && (
            <GocardlessItem
              active={_.get(invitation, 'isActive')}
              title="Invitation"
              status={invitation.status}
              name={invitation.customerName}
              email={invitation.customerEmail}
              createdAt={formatDate(invitation.sentAt)}
              url={invitation.gocardlessUrl}
              removeItem={() => removeInvitation(invitation.id)}
              openGoCardlessItemUrlLink={openGoCardlessItemUrlLink}
            />
          )}
          {!_.isNil(customer) && (
            <GocardlessItem
              active={customer.isActive}
              title="Mandate"
              status={customer.status}
              name={customer.name}
              email={customer.email}
              createdAt={formatDate(customer.createdAt)}
              url={customer.gocardlessUrl}
              removeItem={() => removeCustomer(customer.id)}
              openDetailModal={() => openGocardlessCustomerModal(customer.id)}
              openGoCardlessItemUrlLink={openGoCardlessItemUrlLink}
            />
          )}
        </div>
      )}
      <div className="footer">
        <Button blue onClick={openSetupGocardlessModal}>
          Setup GoCardless
        </Button>
      </div>
    </div>
  );
};

export default GocardlessPaymentMethod;
